import script from "./PersonAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonAvatar.vue?vue&type=script&setup=true&lang=js"

import "./PersonAvatar.vue?vue&type=style&index=0&id=128c876a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-128c876a"]])

export default __exports__